/** Panelin desteklediği arayüz dilleri (assets/i18n/*.json). */
export const SUPPORTED_LANGUAGES = ['en', 'tr', 'bg', 'de'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export interface InitialLanguageInput {
    /** localStorage 'language' değeri. */
    saved?: string | null;
    /** navigator.language (ör. 'tr-TR'). */
    navigatorLanguage?: string | null;
    /** TranslateService.getBrowserLang() */
    browserLang?: string | null;
    /** TranslateService.getBrowserCultureLang() */
    browserCultureLang?: string | null;
}

function isSupported(lang: string | null | undefined): lang is SupportedLanguage {
    return !!lang && (SUPPORTED_LANGUAGES as readonly string[]).includes(lang);
}

/**
 * Açılış dili (panel arayüz yenileme §0): kayıtlı desteklenen dil > tarayıcı dili tr* ise 'tr' >
 * desteklenen tarayıcı dili > 'tr'. Seçici (language-switcher) kaydı yazdığı için kullanıcının seçimi kalıcıdır.
 */
export function resolveInitialLanguage(input: InitialLanguageInput): SupportedLanguage {
    if (isSupported(input.saved)) {
        return input.saved;
    }
    if ((input.navigatorLanguage ?? '').toLowerCase().startsWith('tr')) {
        return 'tr';
    }
    const browser = (input.browserLang || input.browserCultureLang || '').split('-')[0].toLowerCase();
    return isSupported(browser) ? browser : 'tr';
}
